/**
 * Whether this browser is being used as a valley screen.
 *
 * One flag, and it exists for one reason: a RELOAD MUST NOT BE A WAY OUT.
 *
 * The full valley leaves an authenticated session running on a screen and
 * puts a PIN in front of the way back to the account. If that were only a
 * piece of React state, F5 would drop the whole arrangement and land on the
 * ledger -- and a gate that a reload walks round is not a gate. So the mode
 * is written down, and `App` reads it before deciding what to render.
 *
 * `localStorage`, not `sessionStorage`. A kitchen screen gets closed, the
 * laptop lid goes down, the browser restarts after an update; every one of
 * those ends the tab, and a valley that quietly became the ledger overnight
 * is exactly the failure this is preventing.
 *
 * IT IS NOT A CREDENTIAL AND GUARDS NOTHING BY ITSELF. Anybody who can clear
 * it can also read everything else this app keeps in local storage. What it
 * does is make the honest case -- a reload, a restart, a closed lid -- come
 * back to the valley rather than to the account. See the note in
 * `screens/FullValley.tsx` about what that gate is and is not.
 */

const KEY = 'valley.display.mode';

export function inValleyMode(): boolean {
  try {
    return localStorage.getItem(KEY) === 'on';
  } catch {
    // Private mode, or site data turned off. The valley still runs for this
    // tab; it just will not come back by itself after a reload.
    return false;
  }
}

export function rememberValleyMode(): void {
  try {
    localStorage.setItem(KEY, 'on');
  } catch {
    /* as above */
  }
}

export function forgetValleyMode(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* as above */
  }
}
